import React, { ReactElement } from 'react';

import { format } from '@philips-emr/tws-core/lib/services/model-service';

import { Input } from '../..';

interface Props {
  calendar: ReactElement | null;
  enabled: boolean;
  endDate?: string;
  onClick: () => void;
  placeholder?: string;
  readOnly: boolean;
  startDate: string;
  valid: boolean;
}

function formatDate(value: string): string {
  return format<string>('date', value);
}

function joinDates(startDate: string, endDate?: string): string {
  if (endDate) {
    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
  }

  return formatDate(startDate);
}

function DateFieldInterval(props: Props): ReactElement {
  const { calendar, enabled, endDate, onClick, placeholder, readOnly, startDate, valid  } = props;

  const value = joinDates(startDate, endDate);

  return (
    <div className="c-date-field__container">
      <div className="c-date-field--interval" onClick={onClick}>
        <Input enabled={enabled} externalAction={calendar} onFocus={onClick} placeholder={placeholder} readOnly={readOnly} valid={valid} value={value} />
      </div>
    </div>
  );
}

export default DateFieldInterval;
